import React, { useState } from 'react';
import './PreguntasFrecuentes.css';

const PreguntasFrecuentes = ({ onBack }) => {
    const [expandido, setExpandido] = useState(null);

    const toggleExpand = (index) => {
        setExpandido(expandido === index ? null : index);
    };

    const preguntas = [
        {
            categoria: "Cuenta y Registro",
            items: [
                {
                    pregunta: "¿Cómo creo una cuenta en LOTEA?",
                    respuesta: "Para crear una cuenta, haz clic en 'Registrarse' en la página principal. Completa el formulario con tu nombre, correo electrónico y contraseña. Recibirás un correo de verificación. Haz clic en el enlace para activar tu cuenta. Una vez activada, podrás usar LOTEA de forma gratuita mientras el servicio se ofrezca sin suscripciones."
                },
                {
                    pregunta: "¿Cómo resetting mi contraseña?",
                    respuesta: "En la página de inicio de sesión, haz clic en '¿Olvidaste tu contraseña?'. Ingresa tu correo electrónico y recibirás un enlace para restablecer tu contraseña. El enlace expirará en 1 hora por seguridad."
                },
                {
                    pregunta: "¿Puedo cambiar mi dirección de correo electrónico?",
                    respuesta: "Sí, puedes cambiar tu correo desde la sección 'Perfil' en tu Dashboard. Deberás verificar el nuevo correo antes de que el cambio sea efectivo."
                },
                {
                    pregunta: "¿Cómo elimino mi cuenta?",
                    respuesta: "Para eliminar tu cuenta, ve a 'Configuración' > 'Privacidad y datos' > 'Eliminar cuenta'. Se te pedirá que confirmes esta acción. Una vez eliminada, tu cuenta y todos tus datos serán borrados permanentemente en 30 días. No podrás recuperarlos después."
                }
            ]
        },
        {
            categoria: "Suscripcción y Pagos (actualmente deshabilitados)",
            items: [
                {
                    pregunta: "¿Cuáles son los planes disponibles?",
                    respuesta: "Por ahora LOTEA se ofrece como una única versión gratuita del sistema, sin planes ni suscripciones activas. Más adelante se podrían habilitar planes de pago, pero actualmente no es necesario contratar nada para usar la plataforma."
                },
                {
                    pregunta: "¿Qué métodos de pago aceptan?",
                    respuesta: "Aceptamos tarjetas de crédito y débito (Visa, Mastercard, American Express). Los pagos son procesados de forma segura a través de proveedores certificados en estándares de seguridad PCI DSS."
                },
                {
                    pregunta: "¿Es seguro pagar con LOTEA?",
                    respuesta: "Sí, completamente. No almacenamos números de tarjeta en nuestros servidores. Todos los pagos son procesados por proveedores especializados en pagos que utilizan encriptación de 256 bits. Tu información de pago está totalmente protegida."
                },
                {
                    pregunta: "¿Cómo cambio mi plan de suscripción?",
                    respuesta: "Puedes cambiar tu plan en cualquier momento desde 'Suscripción' > 'Cambiar plan'. Si cambias a un plan más caro, pagarás la diferencia prorrateada. Si cambias a uno más barato, el crédito se aplicará a tu próxima facturación."
                },
                {
                    pregunta: "¿Puedo cancelar mi suscripción?",
                    respuesta: "Sí, puedes cancelar en cualquier momento desde 'Suscripción' > 'Gestionar suscripción'. La cancelación entra en vigor al final del período de facturación actual. No hay penalizaciones por cancelación temprana."
                },
                {
                    pregunta: "¿Qué ocurre si cancelo mi suscripción?",
                    respuesta: "Tu acceso a LOTEA continuará hasta el final de tu período de facturación actual. Después, tu cuenta se convertirá a acceso limitado. Tus datos serán conservados durante 30 días. Si reactivas tu suscripción dentro de ese tiempo, recuperarás acceso completo."
                },
                {
                    pregunta: "¿Ofrecen reembolsos?",
                    respuesta: "Actualmente LOTEA se ofrece de forma gratuita, por lo que no se generan cobros ni reembolsos. Si en el futuro se habilitan planes de pago, se documentarán allí las políticas de reembolso."
                },
                {
                    pregunta: "¿Se renuevan las suscripciones automáticamente?",
                    respuesta: "En este momento no existen suscripciones activas en LOTEA. Cuando en el futuro se incorporen planes de pago, se indicará claramente cómo funciona la renovación automática."
                }
            ]
        },
        {
            categoria: "Funcionalidades de LOTEA",
            items: [
                {
                    pregunta: "¿Cómo creo un nuevo proyecto de lotes?",
                    respuesta: "En tu Dashboard, haz clic en 'Nuevo Proyecto'. Completa los detalles básicos (nombre, descripción, ubicación). Luego puedes agregar lotes, cargar planos y configurar propiedades. El proyecto se guardará automáticamente en la nube."
                },
                {
                    pregunta: "¿Cómo cargo un plano en LOTEA?",
                    respuesta: "En tu proyecto, ve a la sección 'Planos' y haz clic en 'Cargar plano'. Puedes subir archivos en formato JPG o PNG. Una vez cargado, podrás visualizarlo de forma interactiva, agregar marcadores y realizar mediciones."
                },
                {
                    pregunta: "¿Qué formatos de archivo soportan?",
                    respuesta: "Actualmente soportamos JPG, PNG. Los archivos no deben exceder 50 MB. Para mejores resultados, usa archivos con alta resolución."
                },
                {
                    pregunta: "¿Cómo creo un nuevo lote?",
                    respuesta: "En tu proyecto, haz clic en 'Agregar lote'. Completa los detalles (número, área, ubicación, precio, etc.). Puedes asignar el lote a un plano específico para visualizarlo sobre el documento. Los cambios se guardan automáticamente."
                },
                {
                    pregunta: "¿Cómo visualizo los lotes en el plano?",
                    respuesta: "Usa el 'Plano Interactivo' para ver los lotes superpuestos en tu documento. Puedes hacer clic en cada lote para ver sus detalles, editar información o agregar notas. El plano es completamente interactivo con zoom y desplazamiento."
                },
                {
                    pregunta: "¿Puedo editar un lote después de crearlo?",
                    respuesta: "Sí, completamente. Desde la lista de lotes o desde el plano interactivo, haz clic en el lote y selecciona 'Editar'. Puedes cambiar cualquier información. Los cambios se guardan instantáneamente."
                },
                {
                    pregunta: "¿Cómo elimino un lote?",
                    respuesta: "Selecciona el lote desde la lista o el plano, haz clic en 'Más opciones' y selecciona 'Eliminar'. Se te pedirá confirmación. Esta acción no es reversible, así que asegúrate antes de confirmar."
                },
                {
                    pregunta: "¿Puedo exportar mis datos?",
                    respuesta: "Sí, puedes exportar tu información de proyectos y lotes en formato Excel (XLSX) o PDF. Ve a tu proyecto, haz clic en 'Exportar' y selecciona el formato."
                },
                {
                    pregunta: "¿Puedo compartir proyectos con otros usuarios?",
                    respuesta: "Actualmente, cada usuario tiene acceso solo a sus propios proyectos. Estamos desarrollando funcionalidades de colaboración para futuras versiones."
                }
            ]
        },
        {
            categoria: "Datos y Seguridad",
            items: [
                {
                    pregunta: "¿Mis datos están seguros en LOTEA?",
                    respuesta: "Sí, utilizamos encriptación de nivel industrial (SSL/TLS) para todas las comunicaciones. Tus datos se almacenan en servidores seguros con acceso restringido. Realizamos copias de seguridad diarias."
                },
                {
                    pregunta: "¿Cuándo se hacen copias de seguridad?",
                    respuesta: "Hacemos copias de seguridad automáticas diarias de todos los datos. Si necesitas restaurar información, contacta a soporte y evaluaremos tu solicitud."
                },
                {
                    pregunta: "¿Qué ocurre con mis datos si cancelo mi suscripción?",
                    respuesta: "Tus datos se conservan durante 30 días después de la cancelación. Dentro de ese período, puedes reacticar tu suscripción y recuperar todo. Después de 30 días, los datos se eliminan permanentemente."
                },
                {
                    pregunta: "¿Venden mis datos a terceros?",
                    respuesta: "No, LOTEA nunca vende tus datos. Solo compartimos información con proveedores necesarios para operar el servicio (hosting, pagos, etc.), y siempre bajo acuerdos de confidencialidad."
                },
                {
                    pregunta: "¿Cómo solicito mis datos personales?",
                    respuesta: "Puedes solicitar una copia de todos tus datos desde 'Configuración' > 'Privacidad y datos' > 'Descargar mis datos'. Recibirás un archivo con toda tu información en 7 días hábiles."
                }
            ]
        },
        {
            categoria: "Problemas Técnicos",
            items: [
                {
                    pregunta: "¿Por qué no puedo iniciar sesión?",
                    respuesta: "Verifica que escribas correctamente tu correo y contraseña (recuerda que son sensibles a mayúsculas). Si olvidaste tu contraseña, usa la opción 'Recuperar contraseña'. Si el problema persiste, contacta a soporte."
                },
                {
                    pregunta: "¿El plano no carga correctamente?",
                    respuesta: "Intenta: 1) Recargar la página (F5 o Cmd+R), 2) Limpiar caché (Ctrl+Shift+Supr), 3) Intentar en otro navegador, 4) Verificar que el archivo no sea demasiado grande (máx 50 MB)."
                },
                {
                    pregunta: "¿Mi sesión se cierra automáticamente?",
                    respuesta: "Por seguridad, las sesiones se cierran después de 30 minutos de inactividad. Esto protege tu cuenta. Simplemente vuelve a iniciar sesión."
                },
                {
                    pregunta: "¿Qué navegadores soportan LOTEA?",
                    respuesta: "LOTEA funciona en navegadores modernos: Chrome (versión 90+), Firefox (88+), Safari (14+) y Edge (90+). Recomendamos usar la última versión de tu navegador."
                },
                {
                    pregunta: "¿Puedo usar LOTEA en móvil?",
                    respuesta: "LOTEA está optimizado para escritorio. Puedes acceder desde móvil, pero la experiencia es mejor en pantallas grandes."
                },
                {
                    pregunta: "¿Qué debo hacer si encuentro un error?",
                    respuesta: "Abre una solicitud de soporte en el Centro de Soporte. Incluye una captura de pantalla, los pasos para reproducir el error y información de tu navegador. Esto nos ayudará a resolver rápidamente."
                }
            ]
        },
        {
            categoria: "General",
            items: [
                {
                    pregunta: "¿Cómo puedo obtener una demostración de LOTEA?",
                    respuesta: "Puedes registrarte y usar LOTEA de forma gratuita mientras el servicio se ofrezca sin suscripciones. Esta es la mejor forma de probar LOTEA. Si necesitas una demo guiada, contacta a soporte para coordinar."
                },
                {
                    pregunta: "¿Ofrecen descuentos para empresas o múltiples usuarios?",
                    respuesta: "Estamos trabajando en planes empresariales. Contacta a soporte para discutir opciones personalizadas para tu organización."
                },
                {
                    pregunta: "¿Con qué frecuencia se actualiza LOTEA?",
                    respuesta: "Lanzamos nuevas funcionalidades y mejoras regularmente. Notificamos a los usuarios sobre actualizaciones importantes a través de correo electrónico."
                },
                {
                    pregunta: "¿Cómo sugiero nuevas funcionalidades?",
                    respuesta: "Nos encanta recibir feedback. Puedes enviar sugerencias a través del Centro de Soporte. Leemos todas las sugerencias y las consideramos para futuras versiones."
                }
            ]
        }
    ];

    return (
        <div className="public-page">
            <header className="public-page-header">
                <button className="btn-secondary" onClick={onBack}>
                    Volver
                </button>
                <h2>Preguntas Frecuentes (FAQ)</h2>
                <p>Encuentra respuestas a las dudas más comunes sobre LOTEA</p>
            </header>

            <section className="public-page-content">
                {preguntas.map((categoria, catIndex) => (
                    <div key={catIndex} style={{ marginBottom: '30px' }}>
                        <h3 style={{
                            borderBottom: '2px solid #007bff',
                            paddingBottom: '10px',
                            marginBottom: '15px'
                        }}>
                            {categoria.categoria}
                        </h3>

                        {categoria.items.map((item, itemIndex) => {
                            const uniqueIndex = `${catIndex}-${itemIndex}`;
                            const isExpanded = expandido === uniqueIndex;

                            return (
                                <div
                                    key={itemIndex}
                                    style={{
                                        marginBottom: '10px',
                                        border: '1px solid #ddd',
                                        borderRadius: '4px',
                                        overflow: 'hidden'
                                    }}
                                >
                                    <button
                                        onClick={() => toggleExpand(uniqueIndex)}
                                        style={{
                                            width: '100%',
                                            padding: '15px',
                                            backgroundColor: isExpanded ? '#e7f3ff' : '#f9f9f9',
                                            border: 'none',
                                            textAlign: 'left',
                                            cursor: 'pointer',
                                            fontSize: '1rem',
                                            fontWeight: '600',
                                            display: 'flex',
                                            justifyContent: 'space-between',
                                            alignItems: 'center',
                                            transition: 'background-color 0.3s'
                                        }}
                                        onMouseEnter={(e) => e.target.style.backgroundColor = '#e7f3ff'}
                                        onMouseLeave={(e) => e.target.style.backgroundColor = isExpanded ? '#e7f3ff' : '#f9f9f9'}
                                    >
                                        <span>{item.pregunta}</span>
                                        <span style={{ fontSize: '1.2rem' }}>
                                            {isExpanded ? '▼' : '▶'}
                                        </span>
                                    </button>

                                    {isExpanded && (
                                        <div
                                            style={{
                                                padding: '15px',
                                                backgroundColor: '#fff',
                                                borderTop: '1px solid #ddd',
                                                lineHeight: '1.6',
                                                color: '#333'
                                            }}
                                        >
                                            {item.respuesta}
                                        </div>
                                    )}
                                </div>
                            );
                        })}
                    </div>
                ))}

                <div style={{
                    marginTop: '40px',
                    padding: '20px',
                    backgroundColor: '#f0f0f0',
                    borderRadius: '8px',
                    textAlign: 'center'
                }}>
                    <h3>¿No encontraste respuesta?</h3>
                    <p>
                        Si tu pregunta no está en esta lista, contacta a nuestro equipo de soporte.
                        Estamos disponibles para ayudarte.
                    </p>
                    <button
                        onClick={() => window.location.href = '#soporte'}
                        style={{
                            padding: '10px 20px',
                            backgroundColor: '#007bff',
                            color: 'white',
                            border: 'none',
                            borderRadius: '4px',
                            cursor: 'pointer',
                            fontSize: '1rem',
                            fontWeight: 'bold'
                        }}
                    >
                        Ir al Centro de Soporte
                    </button>
                </div>
            </section>
        </div>
    );
};

export default PreguntasFrecuentes;